/**
 * Operations chart colors. The three touch series passed the dataviz six-check
 * validator on the light (#fcfcfb) and dark (#171c26) surfaces, adjacent CVD
 * ΔE >= 22. Literal class strings so Tailwind's JIT compiles them; never build
 * them dynamically. Single-series bars use the first slot.
 */
export const SERIES_BG = "bg-[#3b65ba] dark:bg-[#406abf]";
export const SERIES_BG_SOFT = "bg-[#3b65ba]/35 dark:bg-[#406abf]/45";
export const SERIES_STROKE = "stroke-[#3b65ba] dark:stroke-[#406abf]";
export const SERIES_FILL_SOFT = "fill-[#3b65ba]/15 dark:fill-[#406abf]/25";
/** Second identity where one chart splits two things (prospect vs became a client). */
export const CLIENT_BG = "bg-[#bc5e2f] dark:bg-[#cf6a3a]";
export const TRACK_BG = "bg-muted";
export const TOUCH_BG = {
  email: "bg-[#3b65ba] dark:bg-[#406abf]",
  meeting: "bg-[#bc5e2f] dark:bg-[#cf6a3a]",
  call: "bg-[#9540bf] dark:bg-[#9f53c6]",
} as const;
